import React from 'react';
import PropTypes from 'prop-types';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import { getErrorText } from 'utils/contact';


const ErrorPopover = ({ targetId, contact }) => (
  <UncontrolledPopover
    className="zindex-modal sequence-create__contacts-ready__popover"
    trigger="legacy"
    placement="auto"
    target={targetId}
    delay={0}
    role="tooltip"
  >
    <PopoverBody>
      {contact.errors.map((err, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <React.Fragment key={i}>
          {getErrorText(err)}
          {i + 1 !== contact.errors.length && <hr className="mtb-25" />}
        </React.Fragment>
      ))}
    </PopoverBody>
  </UncontrolledPopover>
);

ErrorPopover.propTypes = {
  targetId: PropTypes.string.isRequired,
  contact: PropTypes.shape({
    errors: PropTypes.arrayOf(PropTypes.shape({
      error_type: PropTypes.string.isRequired,
      additional_data: PropTypes.string,
    })),
  }).isRequired,
};

export default ErrorPopover;
